import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const editIcon = createIconDefinition(
  'edit',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.66667 11.4587L8.3125 9.16699H11.8542L6.66667 5.08366V11.4587ZM11.4792 18.3337L8.45833 11.8337L5 16.667V1.66699L16.6667 10.8337H10.75L13.75 17.2712L11.4792 18.3337Z" fill="#232426" fill-opacity="0.6"/>
</svg>`,
);
